import React, { useState, useEffect } from "react";
import { Plus, X, ArrowRightLeft, Trash2, ArrowRight, Download } from "lucide-react";
import { api } from "../../utils/api";
import * as XLSX from "xlsx";

const formatTL = (value) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(value || 0);
const formatDate = (d) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export default function Transfers() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/transfers").then(r => {
      setList(r.data || []);
      setLoading(false);
    }).catch(err => {
      console.error("Transferler çekilemedi:", err);
      setLoading(false);
    });
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (window.confirm("Bu transfer kaydını silmek istediğinize emin misiniz?")) {
      try {
        await api.delete(`/transfers/${id}`);
        load();
      } catch (err) {
        alert("Silme işlemi başarısız oldu.");
      }
    }
  };

  // EXCEL'E AKTARMA FONKSİYONU
  const exportToExcel = () => {
    if (list.length === 0) {
      alert("Dışa aktarılacak kayıt bulunamadı.");
      return;
    }

    const dataToExport = list.map(t => ({
      "Tarih": formatDate(t.date),
      "Açıklama": t.description,
      "Nereden (Çıkış)": t.from_account,
      "Nereye (Giriş)": t.to_account,
      "Tutar (TL)": Number(t.amount || 0)
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transferler");
    XLSX.writeFile(wb, "Hesaplar_Arasi_Transferler.xlsx");
  };

  return (
    <div style={{ animation: "fadeIn 0.4s ease-out" }}>
      
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", background: "white", padding: "24px 30px", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", marginBottom: "24px", gap: "20px" }}>
        <div>
          <span style={{ fontSize: "12px", fontWeight: "bold", color: "#8b5cf6", letterSpacing: "1px", textTransform: "uppercase" }}>HESAPLAR ARASI (VİRMAN)</span>
          <h2 style={{ margin: "6px 0", fontSize: "22px", color: "#1e293b" }}>Para Transferleri</h2>
          <p style={{ margin: 0, fontSize: "14px", color: "#64748b" }}>Banka hesapları ve kasa arası virman ile malik iade işlemlerini yönetin.</p>
        </div>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <button onClick={exportToExcel} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#10b981", color: "white", border: "none", padding: "12px 20px", borderRadius: "8px", fontWeight: "bold", cursor: "pointer", transition: "background 0.2s" }}>
            <Download size={18} /> Excel'e Aktar
          </button>
          <button onClick={() => setModal(true)} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#3b82f6", color: "white", border: "none", padding: "12px 20px", borderRadius: "8px", fontWeight: "bold", cursor: "pointer", transition: "background 0.2s", boxShadow: "0 2px 10px rgba(59, 130, 246, 0.3)" }}>
            <Plus size={18} /> Yeni Transfer
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ padding: "40px", textAlign: "center", color: "#64748b" }}>Transfer kayıtları yükleniyor...</div>
      ) : list.length > 0 ? (
        <div style={{ background: "white", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.02)", overflow: "hidden" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Tarih</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600" }}>Açıklama</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600", textAlign: "center" }}>Transfer Yönü</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600", textAlign: "right" }}>Tutar</th>
                  <th style={{ padding: "16px", fontSize: "13px", color: "#64748b", fontWeight: "600", textAlign: "center" }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {list.map(t => (
                  <tr key={t.id} style={{ borderBottom: "1px solid #f1f5f9", transition: "background 0.2s" }} onMouseOver={e => e.currentTarget.style.background = '#f8fafc'} onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: "14px 16px", color: "#64748b", fontSize: "14px", fontWeight: "500" }}>{formatDate(t.date)}</td>
                    <td style={{ padding: "14px 16px", fontWeight: "600", color: "#334155" }}>{t.description}</td>
                    <td style={{ padding: "14px 16px", textAlign: "center" }}>
                      <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "#f1f5f9", padding: "6px 12px", borderRadius: "20px", fontSize: "13px", fontWeight: "600" }}>
                        <span style={{ color: "#ef4444" }}>{t.from_account}</span>
                        <ArrowRight size={14} color="#94a3b8" />
                        <span style={{ color: "#10b981" }}>{t.to_account}</span>
                      </div>
                    </td>
                    <td style={{ padding: "14px 16px", textAlign: "right", fontWeight: "bold", color: "#1e293b", fontSize: "15px" }}>{formatTL(t.amount)}</td>
                    <td style={{ padding: "14px 16px", textAlign: "center" }}>
                      <button onClick={() => remove(t.id)} title="Sil" style={{ background: "#fef2f2", color: "#ef4444", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer", display: "inline-flex" }}>
                        <Trash2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", border: "1px dashed #cbd5e1", padding: "60px 20px", textAlign: "center", color: "#64748b" }}>
          <ArrowRightLeft size={48} color="#cbd5e1" style={{ marginBottom: "16px" }} />
          <h3 style={{ margin: "0 0 8px 0", color: "#1e293b" }}>Henüz transfer kaydı yok</h3>
          <p style={{ margin: 0, fontSize: "14px" }}>Hesaplarınız arası nakit akışını ve iadeleri girmek için Yeni Transfer butonunu kullanın.</p>
        </div>
      )}

      {modal && <TransferModal close={() => setModal(false)} done={() => { setModal(false); load(); }} />}
    </div>
  );
}

function TransferModal({ close, done }) {
  const [form, setForm] = useState({
    date: new Date().toISOString().slice(0, 10),
    from_account: "İş Bankası",
    to_account: "Kasa",
    amount: "",
    description: "İş Bankası hesabından nakit para çekme"
  });

  const [autoDesc, setAutoDesc] = useState(true);

  useEffect(() => {
    if (!autoDesc) return;
    const src = form.from_account;
    const dst = form.to_account;
    let desc = "";

    if (src === dst) { desc = "Hatalı seçim (Aynı hesaba transfer yapılamaz)"; } 
    else if (src === "Devir") { desc = `${dst} hesabına dönem devri (Açılış bakiyesi)`; } 
    else if (dst === "Diğer") { desc = `${src} hesabından malik iadesi / diğer çıkış`; } 
    else if (src === "Diğer") { desc = `${dst} hesabına dış kaynaklı / diğer giriş`; } 
    else if (dst === "Kasa" || dst === "Nakit") { desc = `${src} hesabından nakit para çekme`; } 
    else if (src === "Kasa" || src === "Nakit") { desc = `${dst} hesabına nakit para yatırma`; } 
    else { desc = `${src} hesabından ${dst} hesabına virman`; }

    setForm(f => ({ ...f, description: desc }));
  }, [form.from_account, form.to_account, autoDesc]);

  const change = e => setForm({ ...form, [e.target.name]: e.target.value });
  const changeDesc = e => { setAutoDesc(false); setForm({ ...form, description: e.target.value }); };
  
  const submit = async e => {
    e.preventDefault();
    if (form.from_account === form.to_account) { alert("Kaynak ve hedef hesap aynı olamaz!"); return; }
    try {
      await api.post("/transfers", { ...form, amount: Number(form.amount) });
      done();
    } catch (x) { alert("Kayıt başarısız oldu. Lütfen tekrar deneyin."); }
  };

  const accounts = [
    { name: "Kasa", label: "Kasa (100.01)" },
    { name: "İş Bankası", label: "İş Bankası (102.01)" },
    { name: "Ziraat Bankası", label: "Ziraat Bankası (102.02)" },
    { name: "Devir", label: "Dönem Devri / Açılış" },
    { name: "Diğer", label: "Diğer / Malik İadesi (120.00)" }
  ];

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "white", width: "100%", maxWidth: "550px", borderRadius: "20px", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)", overflow: "hidden", animation: "slideUp 0.3s ease-out" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
          <div><span style={{ fontSize: "12px", fontWeight: "bold", color: "#8b5cf6", letterSpacing: "1px" }}>YENİ VİRMAN</span><h2 style={{ margin: "4px 0 0 0", fontSize: "18px", color: "#1e293b" }}>Para Transferi</h2></div>
          <button onClick={close} style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer", padding: "4px", display: "flex" }}><X size={24} /></button>
        </div>
        <form onSubmit={submit} style={{ padding: "24px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px" }}>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Tarih</label><input name="date" type="date" value={form.date} onChange={change} required style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", fontSize: "14px", fontFamily: "inherit" }} /></div>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Tutar (TL)</label><input name="amount" type="number" min="1" step="0.01" value={form.amount} onChange={change} placeholder="0,00" required style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", fontSize: "14px", fontFamily: "inherit", fontWeight: "bold", color: "#1e293b" }} /></div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "16px", background: "#f1f5f9", padding: "16px", borderRadius: "12px" }}>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#ef4444", marginBottom: "6px" }}>Nereden (Çıkış)</label><select name="from_account" value={form.from_account} onChange={change} style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", fontSize: "14px", fontFamily: "inherit", background: "white" }}>{accounts.map(a => <option key={a.name} value={a.name}>{a.label}</option>)}</select></div>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#10b981", marginBottom: "6px" }}>Nereye (Giriş)</label><select name="to_account" value={form.to_account} onChange={change} style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", fontSize: "14px", fontFamily: "inherit", background: "white" }}>{accounts.map(a => <option key={a.name} value={a.name}>{a.label}</option>)}</select></div>
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px", fontWeight: "600", color: "#475569", marginBottom: "6px" }}>Açıklama {!autoDesc && <span style={{ color: "#f59e0b", fontSize: "11px", fontWeight: "bold" }}> (Elle Düzenlendi)</span>}</label>
            <input name="description" value={form.description} onChange={changeDesc} required style={{ width: "100%", padding: "12px", borderRadius: "8px", border: "1px solid #cbd5e1", outline: "none", fontSize: "14px", fontFamily: "inherit", color: "#334155" }} />
          </div>
          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}><button type="button" onClick={close} style={{ padding: "12px 20px", background: "white", border: "1px solid #cbd5e1", borderRadius: "8px", color: "#475569", fontWeight: "600", cursor: "pointer" }}>Vazgeç</button><button type="submit" style={{ padding: "12px 24px", background: "#3b82f6", border: "none", borderRadius: "8px", color: "white", fontWeight: "bold", cursor: "pointer", boxShadow: "0 2px 10px rgba(59, 130, 246, 0.3)" }}>İşlemi Kaydet</button></div>
        </form>
      </div>
    </div>
  );
}